import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // Превью прилипает к экрану на высоте шапки (theme.spacing(11)), поэтому не
  // выше окна: иначе низ сообщения с высокой картинкой уходит за край, пока не
  // долистаешь всю форму. `reserve` — место под кнопки, которые стоят под превью.
  phone: ({ reserve }) => ({
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid #d8d8d8',
    backgroundColor: '#ECE5DD',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '320px',
    maxHeight: `calc(100vh - ${theme.spacing(11) + theme.spacing(2) + reserve}px)`,
  }),
  header: {
    backgroundColor: '#075E54',
    color: '#fff',
    padding: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    backgroundColor: '#25D366',
    color: '#fff',
    width: '36px',
    height: '36px',
    marginRight: theme.spacing(1.5),
    fontWeight: 'bold',
  },
  // Длинное сообщение прокручивается внутри превью, шапка чата остаётся на месте.
  chat: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  bubble: {
    position: 'relative',
    maxWidth: '85%',
    backgroundColor: '#DCF8C6',
    borderRadius: '8px',
    borderTopRightRadius: 0,
    padding: theme.spacing(1, 1.5, 0.5, 1.5),
    boxShadow: '0 1px 1px rgba(0,0,0,0.12)',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  // Высокая афиша не выше половины окна, чтобы под ней было видно начало текста.
  // Раскладку текстов на картинке точно видно в большом редакторе слева.
  image: {
    display: 'block',
    width: 'auto',
    maxWidth: '100%',
    maxHeight: '55vh',
    margin: '0 auto',
    borderRadius: '6px',
    marginBottom: theme.spacing(0.75),
  },
  bubbleText: {
    fontSize: '14px',
    lineHeight: 1.45,
    color: '#111',
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(0.5),
    color: '#667781',
  },
  footer: {
    display: 'block',
    marginTop: theme.spacing(0.5),
    fontSize: '12px',
    color: '#667781',
  },
  metaTime: {
    fontSize: '11px',
    marginRight: theme.spacing(0.5),
  },
  metaIcon: {
    fontSize: '15px',
    color: '#4FC3F7',
  },
  button: {
    maxWidth: '85%',
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 1px rgba(0,0,0,0.12)',
    textAlign: 'center',
    fontSize: '14px',
    color: '#00a5f4',
  },
  placeholder: {
    margin: 'auto',
    textAlign: 'center',
    color: '#54656f',
    padding: theme.spacing(3),
  },
}));

// Предпросмотр рассылки так, как её увидит клиент в WhatsApp.
//   reserve — сколько пикселей оставить под превью для кнопок рядом с ним.
function WhatsappPreview(props) {
  const { text, footer, time, emptyText, imageUrl, buttons = [], reserve = 0 } = props;
  const classes = useStyles({ reserve });
  const messageText = text || '';

  return (
    <div className={classes.phone}>
      <div className={classes.header}>
        <Avatar className={classes.avatar}>G</Avatar>
        <div>
          <Typography variant="subtitle2">GradOil</Typography>
          <Typography variant="caption">WhatsApp · Business</Typography>
        </div>
      </div>
      <div className={classes.chat}>
        {messageText || imageUrl ? (
          <>
            <div className={classes.bubble}>
              {imageUrl && <img src={imageUrl} alt="" className={classes.image} />}
              <span className={classes.bubbleText}>{messageText}</span>
              {footer && <span className={classes.footer}>{footer}</span>}
              <div className={classes.meta}>
                <span className={classes.metaTime}>{time}</span>
                <DoneAllIcon className={classes.metaIcon} />
              </div>
            </div>
            {buttons.map((label) => (
              <div key={label} className={classes.button}>
                {label}
              </div>
            ))}
          </>
        ) : (
          <Typography variant="body2" className={classes.placeholder}>
            {emptyText ||
              'Выберите шаблон — здесь появится сообщение так, как его увидит клиент.'}
          </Typography>
        )}
      </div>
    </div>
  );
}

export default WhatsappPreview;
